'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setWebinarAttendeeInfo = setWebinarAttendeeInfo;
// POST

var SET_WEBINAR_ATTENDEE_INFO_COMPLETE = exports.SET_WEBINAR_ATTENDEE_INFO_COMPLETE = 'SET_WEBINAR_ATTENDEE_INFO_COMPLETE';

function setWebinarAttendeeInfo(webinarAttendeeInfo) {
    return function (dispatch, getStore) {
        dispatch({ type: SET_WEBINAR_ATTENDEE_INFO_COMPLETE, webinarAttendeeInfo: webinarAttendeeInfo });
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/actions/attendee-info.js
// module id = 791
// module chunks = 0